/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddUsersToTeamRequest,
  AddUsersToWorkspaceRequest,
  AdjustDistributionRequest,
  ApiPermission,
  CallerRef,
  ConciergeIsRouterEnabledResponse,
  ConciergeRoutersListResponse,
  CreateApiKeyRequest,
  CreatePartnerKeyRequest,
  CrmEndpointsResponse,
  HttpQueryResponseA,
  MapString,
  MeetingsEndpointsResponse,
  PaginatedResultDistribution,
  PaginatedResultPartnerApiKey,
  PaginatedResultRuleView,
  PaginatedResultTeam,
  PaginatedResultTenantApiKey,
  PaginatedResultUser,
  PaginatedResultWorkspace,
  PartnerPermission,
  RemoveUserFromAllTeamsRequest,
  RemoveUserFromAllWorkspacesRequest,
  RemoveUserFromTeamRequest,
  RemoveUserFromWorkspaceRequest,
  RoundRobinSchedulingLinksRequest,
  RuleCreateRequest,
  RuleDeleteRequest,
  RuleModifyRequest,
  RuleView,
  SchedulingLinkDetails,
  StaticValue,
  Team,
  TenantInfo,
  TenantMigrationStatusResponse,
  UpdateDistributionRequest,
  UpdateLicensesRequest,
  User,
  UserInviteRequest,
  UserInviteResponse,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "edge-fire";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Query API keys
   *
   * @tags api-keys
   * @name QueryApiKeys
   * @request GET:/v1/tenant/{tenantId}/api-keys
   * @secure
   */
  queryApiKeys = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTenantApiKey,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/api-keys`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryApiKeys */
  queryApiKeysPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/api-keys`, query);

  /**
   * @description Create a new API key. API keys are used to authenticate requests to the Chili Piper API.
   *
   * @tags api-keys
   * @name CreateApiKey
   * @request POST:/v1/tenant/{tenantId}/api-keys
   * @secure
   */
  createApiKey = (tenantId: string, data: CreateApiKeyRequest, params: RequestParams = {}) =>
    this.request<
      CallerRef,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/api-keys`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createApiKey */
  createApiKeyPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/api-keys`);

  /**
   * @description Delete an API key. API keys are used to authenticate requests to the Chili Piper API.
   *
   * @tags api-keys
   * @name DeleteApiKey
   * @request DELETE:/v1/tenant/{tenantId}/api-keys/{apiKey}
   * @secure
   */
  deleteApiKey = (tenantId: string, apiKey: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/api-keys/${apiKey}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiKey */
  deleteApiKeyPathGetter = (tenantId: string, apiKey: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/api-keys/${apiKey}`);

  /**
   * @description List permissions
   *
   * @tags api-keys
   * @name ListPermissions
   * @request GET:/v1/tenant/{tenantId}/api-keys/permissions
   * @secure
   */
  listPermissions = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ApiPermission[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/api-keys/permissions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listPermissions */
  listPermissionsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/api-keys/permissions`);

  /**
   * @description Create a new partner API key. API keys are used to authenticate requests to the Chili Piper API.
   *
   * @tags partner-api-key
   * @name CreatePartnerApiKey
   * @request POST:/v1/partner-api-keys
   */
  createPartnerApiKey = (data: CreatePartnerKeyRequest, params: RequestParams = {}) =>
    this.request<
      CallerRef,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/partner-api-keys`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createPartnerApiKey */
  createPartnerApiKeyPathGetter = () => this.getServicePath(`/v1/partner-api-keys`);

  /**
   * @description Delete an partner API key. API keys are used to authenticate requests to the Chili Piper API.
   *
   * @tags partner-api-key
   * @name DeletePartnerApiKey
   * @request DELETE:/v1/partner-api-keys/{apiKey}
   */
  deletePartnerApiKey = (apiKey: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/partner-api-keys/${apiKey}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletePartnerApiKey */
  deletePartnerApiKeyPathGetter = (apiKey: string) => this.getServicePath(`/v1/partner-api-keys/${apiKey}`);

  /**
   * @description Query Partner API keys
   *
   * @tags partner-api-key
   * @name QueryPartnerApiKeys
   * @request GET:/v1/api-keys
   */
  queryPartnerApiKeys = (
    query?: {
      /**
       * @format int64
       * @min 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultPartnerApiKey,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/api-keys`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryPartnerApiKeys */
  queryPartnerApiKeysPathGetter = (query?: {
    /**
     * @format int64
     * @min 0
     */
    page?: number;
    /**
     * @format int64
     * @exclusiveMin 0
     */
    pageSize?: number;
  }) => this.getServicePath(`/v1/api-keys`, query);

  /**
   * @description List all permissions that can be assigned to a partner API key.
   *
   * @tags partner-api-key
   * @name ListPartnerApiKeyPermissions
   * @request GET:/v1/partner-api-keys/permissions
   */
  listPartnerApiKeyPermissions = (params: RequestParams = {}) =>
    this.request<
      PartnerPermission[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/partner-api-keys/permissions`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listPartnerApiKeyPermissions */
  listPartnerApiKeyPermissionsPathGetter = () => this.getServicePath(`/v1/partner-api-keys/permissions`);

  /**
   * @description Ping api
   *
   * @tags health
   * @name PingApi
   * @request GET:/v1/org/health/ping
   * @secure
   */
  pingApi = (params: RequestParams = {}) =>
    this.request<
      CallerRef,
      {
        errorCode: string;
        errorMessage: string;
        arguments?: MapString;
      }
    >({
      path: `/v1/org/health/ping`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for pingApi */
  pingApiPathGetter = () => this.getServicePath(`/v1/org/health/ping`);

  /**
   * @description Partner ping api
   *
   * @tags health
   * @name PartnerPingApi
   * @request GET:/v1/partner/health/ping
   * @secure
   */
  partnerPingApi = (params: RequestParams = {}) =>
    this.request<
      CallerRef,
      {
        errorCode: string;
        errorMessage: string;
        arguments?: MapString;
      }
    >({
      path: `/v1/partner/health/ping`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for partnerPingApi */
  partnerPingApiPathGetter = () => this.getServicePath(`/v1/partner/health/ping`);

  /**
   * @description Read tenant migration status
   *
   * @tags migration
   * @name ReadTenantMigrationStatus
   * @request GET:/v1/partner/tenant/migration-status
   * @secure
   */
  readTenantMigrationStatus = (
    query: {
      /**
       * Subdomain belonging to customer, e.g. foobar from https://foobar.chilipiper.com
       * @pattern [\w-]{1,2000}
       */
      subdomain: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      TenantMigrationStatusResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/partner/tenant/migration-status`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for readTenantMigrationStatus */
  readTenantMigrationStatusPathGetter = (query: {
    /**
     * Subdomain belonging to customer, e.g. foobar from https://foobar.chilipiper.com
     * @pattern [\w-]{1,2000}
     */
    subdomain: string;
  }) => this.getServicePath(`/v1/partner/tenant/migration-status`, query);

  /**
   * @description Check if a router is enabled in concierge
   *
   * @tags concierge
   * @name CheckIfARouterIsEnabledInConcierge
   * @request GET:/v1/partner/concierge/is-router-enabled
   * @secure
   */
  checkIfARouterIsEnabledInConcierge = (
    query: {
      /**
       * Subdomain belonging to customer, e.g. foobar from https://foobar.chilipiper.com
       * @pattern [\w-]{1,2000}
       */
      subdomain: string;
      /**
       * Slug of the router
       * @pattern [-0-9a-z_]+
       */
      router: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConciergeIsRouterEnabledResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/partner/concierge/is-router-enabled`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkIfARouterIsEnabledInConcierge */
  checkIfARouterIsEnabledInConciergePathGetter = (query: {
    /**
     * Subdomain belonging to customer, e.g. foobar from https://foobar.chilipiper.com
     * @pattern [\w-]{1,2000}
     */
    subdomain: string;
    /**
     * Slug of the router
     * @pattern [-0-9a-z_]+
     */
    router: string;
  }) => this.getServicePath(`/v1/partner/concierge/is-router-enabled`, query);

  /**
   * @description Get information about the tenant
   *
   * @tags tenant
   * @name GetInformationAboutTheTenant
   * @request GET:/v1/org/tenant/get/{tenantId}
   * @secure
   */
  getInformationAboutTheTenant = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantInfo,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/tenant/get/${tenantId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getInformationAboutTheTenant */
  getInformationAboutTheTenantPathGetter = (tenantId: string) => this.getServicePath(`/v1/org/tenant/get/${tenantId}`);

  /**
   * @description Remove users from a workspace
   *
   * @tags workspace
   * @name RemoveUsersFromAWorkspace
   * @request POST:/v1/org/workspace/users/remove
   * @secure
   */
  removeUsersFromAWorkspace = (data: RemoveUserFromWorkspaceRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/workspace/users/remove`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for removeUsersFromAWorkspace */
  removeUsersFromAWorkspacePathGetter = () => this.getServicePath(`/v1/org/workspace/users/remove`);

  /**
   * @description Remove users from all workspaces
   *
   * @tags workspace
   * @name RemoveUsersFromAllWorkspaces
   * @request POST:/v1/org/workspace/users/remove-from-all
   * @secure
   */
  removeUsersFromAllWorkspaces = (data: RemoveUserFromAllWorkspacesRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/workspace/users/remove-from-all`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for removeUsersFromAllWorkspaces */
  removeUsersFromAllWorkspacesPathGetter = () => this.getServicePath(`/v1/org/workspace/users/remove-from-all`);

  /**
   * @description Add users to a workspace
   *
   * @tags workspace
   * @name AddUsersToAWorkspace
   * @request POST:/v1/org/workspace/users/add
   * @secure
   */
  addUsersToAWorkspace = (data: AddUsersToWorkspaceRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/workspace/users/add`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for addUsersToAWorkspace */
  addUsersToAWorkspacePathGetter = () => this.getServicePath(`/v1/org/workspace/users/add`);

  /**
   * @description Read all users (or in a workspace)
   *
   * @tags workspace
   * @name ReadAllUsersOrInAWorkspace
   * @request GET:/v1/org/workspace/users
   * @secure
   */
  readAllUsersOrInAWorkspace = (
    query?: {
      /** @pattern [^\s\\/]+ */
      workspaceId?: string;
      /**
       * Page number. First page has index 0.
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * Number of items per page. Maximum is 50
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUser,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/workspace/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for readAllUsersOrInAWorkspace */
  readAllUsersOrInAWorkspacePathGetter = (query?: {
    /** @pattern [^\s\\/]+ */
    workspaceId?: string;
    /**
     * Page number. First page has index 0.
     * @format int64
     * @min 0
     * @default 0
     * @example 0
     */
    page?: number;
    /**
     * Number of items per page. Maximum is 50
     * @format int64
     * @exclusiveMin 0
     * @default 10
     * @example 10
     */
    pageSize?: number;
  }) => this.getServicePath(`/v1/org/workspace/users`, query);

  /**
   * @description Read all workspaces
   *
   * @tags workspace
   * @name ReadAllWorkspaces
   * @request GET:/v1/org/workspace
   * @secure
   */
  readAllWorkspaces = (
    query?: {
      /**
       * Page number. First page has index 0.
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * Number of items per page. Maximum is 50
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultWorkspace,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/workspace`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for readAllWorkspaces */
  readAllWorkspacesPathGetter = (query?: {
    /**
     * Page number. First page has index 0.
     * @format int64
     * @min 0
     * @default 0
     * @example 0
     */
    page?: number;
    /**
     * Number of items per page. Maximum is 50
     * @format int64
     * @exclusiveMin 0
     * @default 10
     * @example 10
     */
    pageSize?: number;
  }) => this.getServicePath(`/v1/org/workspace`, query);

  /**
   * @description Remove users from a team
   *
   * @tags team
   * @name RemoveUsersFromATeam
   * @request POST:/v1/org/team/users/remove
   * @secure
   */
  removeUsersFromATeam = (data: RemoveUserFromTeamRequest, params: RequestParams = {}) =>
    this.request<
      Team,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/team/users/remove`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for removeUsersFromATeam */
  removeUsersFromATeamPathGetter = () => this.getServicePath(`/v1/org/team/users/remove`);

  /**
   * @description Remove users from all teams (within workspaces or from all workspaces)
   *
   * @tags team
   * @name RemoveUsersFromAllTeamsWithinWorkspacesOrFromAllWorkspaces
   * @request POST:/v1/org/team/users/remove-from-all
   * @secure
   */
  removeUsersFromAllTeamsWithinWorkspacesOrFromAllWorkspaces = (
    data: RemoveUserFromAllTeamsRequest,
    query?: {
      /** List of workspace ids. If not provided, all workspaces are considered. */
      workspaceIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/team/users/remove-from-all`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for removeUsersFromAllTeamsWithinWorkspacesOrFromAllWorkspaces */
  removeUsersFromAllTeamsWithinWorkspacesOrFromAllWorkspacesPathGetter = (query?: {
    /** List of workspace ids. If not provided, all workspaces are considered. */
    workspaceIds?: string[];
  }) => this.getServicePath(`/v1/org/team/users/remove-from-all`, query);

  /**
   * @description Add users to a team
   *
   * @tags team
   * @name AddUsersToATeam
   * @request POST:/v1/org/team/users/add
   * @secure
   */
  addUsersToATeam = (data: AddUsersToTeamRequest, params: RequestParams = {}) =>
    this.request<
      Team,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/team/users/add`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for addUsersToATeam */
  addUsersToATeamPathGetter = () => this.getServicePath(`/v1/org/team/users/add`);

  /**
   * @description Read all teams
   *
   * @tags team
   * @name ReadAllTeams
   * @request GET:/v1/org/team
   * @secure
   */
  readAllTeams = (
    query?: {
      /** List of workspace ids. If not provided, all workspaces are considered. */
      workspaceIds?: string[];
      /**
       * Page number. First page has index 0.
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * Number of items per page. Maximum is 50
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTeam,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/team`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for readAllTeams */
  readAllTeamsPathGetter = (query?: {
    /** List of workspace ids. If not provided, all workspaces are considered. */
    workspaceIds?: string[];
    /**
     * Page number. First page has index 0.
     * @format int64
     * @min 0
     * @default 0
     * @example 0
     */
    page?: number;
    /**
     * Number of items per page. Maximum is 50
     * @format int64
     * @exclusiveMin 0
     * @default 10
     * @example 10
     */
    pageSize?: number;
  }) => this.getServicePath(`/v1/org/team`, query);

  /**
   * @description Update distribution and publish it
   *
   * @tags distribution
   * @name UpdateDistributionAndPublishIt
   * @request POST:/v1/org/distribution/{distributionId}
   * @secure
   */
  updateDistributionAndPublishIt = (
    distributionId: string,
    data: UpdateDistributionRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/distribution/${distributionId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateDistributionAndPublishIt */
  updateDistributionAndPublishItPathGetter = (distributionId: string) =>
    this.getServicePath(`/v1/org/distribution/${distributionId}`);

  /**
   * @description Delete distribution
   *
   * @tags distribution
   * @name DeleteDistribution
   * @request DELETE:/v1/org/distribution/{distributionId}
   * @secure
   */
  deleteDistribution = (distributionId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/distribution/${distributionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteDistribution */
  deleteDistributionPathGetter = (distributionId: string) =>
    this.getServicePath(`/v1/org/distribution/${distributionId}`);

  /**
   * @description List all distributions
   *
   * @tags distribution
   * @name ListAllDistributions
   * @request GET:/v1/org/distribution
   * @secure
   */
  listAllDistributions = (
    query?: {
      /**
       * Page number. First page has index 0.
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * Number of items per page. Maximum is 50
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /** List of workspace ids. If not provided, all workspaces are considered. */
      workspaceIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultDistribution,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/distribution`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllDistributions */
  listAllDistributionsPathGetter = (query?: {
    /**
     * Page number. First page has index 0.
     * @format int64
     * @min 0
     * @default 0
     * @example 0
     */
    page?: number;
    /**
     * Number of items per page. Maximum is 50
     * @format int64
     * @exclusiveMin 0
     * @default 10
     * @example 10
     */
    pageSize?: number;
    /** List of workspace ids. If not provided, all workspaces are considered. */
    workspaceIds?: string[];
  }) => this.getServicePath(`/v1/org/distribution`, query);

  /**
   * @description Adjust distribution by adding or subtracting weights. Anything within weights or manualCalibration will be added to the existing distribution. Can have positive or negative values.
   *
   * @tags distribution
   * @name AdjustDistribution
   * @request POST:/v1/org/distribution/{distributionId}/adjust
   * @secure
   */
  adjustDistribution = (distributionId: string, data: AdjustDistributionRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/distribution/${distributionId}/adjust`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for adjustDistribution */
  adjustDistributionPathGetter = (distributionId: string) =>
    this.getServicePath(`/v1/org/distribution/${distributionId}/adjust`);

  /**
   * @description Updates licenses for users
   *
   * @tags user
   * @name UpdatesLicensesForUsers
   * @request POST:/v1/org/user/licenses
   * @secure
   */
  updatesLicensesForUsers = (data: UpdateLicensesRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/user/licenses`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updatesLicensesForUsers */
  updatesLicensesForUsersPathGetter = () => this.getServicePath(`/v1/org/user/licenses`);

  /**
   * @description Invites new user to the organization
   *
   * @tags user
   * @name InvitesNewUserToTheOrganization
   * @request POST:/v1/org/user/invite
   * @secure
   */
  invitesNewUserToTheOrganization = (data: UserInviteRequest, params: RequestParams = {}) =>
    this.request<
      UserInviteResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/user/invite`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for invitesNewUserToTheOrganization */
  invitesNewUserToTheOrganizationPathGetter = () => this.getServicePath(`/v1/org/user/invite`);

  /**
   * @description Reads user information
   *
   * @tags user
   * @name ReadsUserInformation
   * @request GET:/v1/org/user/read/{userId}
   * @secure
   */
  readsUserInformation = (userId: string, params: RequestParams = {}) =>
    this.request<
      User,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/user/read/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for readsUserInformation */
  readsUserInformationPathGetter = (userId: string) => this.getServicePath(`/v1/org/user/read/${userId}`);

  /**
   * @description Finds user
   *
   * @tags user
   * @name FindsUser
   * @request GET:/v1/org/user/find
   * @secure
   */
  findsUser = (
    query: {
      /** Search by email or name */
      query: string;
      /**
       * Page number. First page has index 0.
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * Number of items per page. Maximum is 50
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUser,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/user/find`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findsUser */
  findsUserPathGetter = (query: {
    /** Search by email or name */
    query: string;
    /**
     * Page number. First page has index 0.
     * @format int64
     * @min 0
     * @default 0
     * @example 0
     */
    page?: number;
    /**
     * Number of items per page. Maximum is 50
     * @format int64
     * @exclusiveMin 0
     * @default 10
     * @example 10
     */
    pageSize?: number;
  }) => this.getServicePath(`/v1/org/user/find`, query);

  /**
   * @description Cancel a meeting via visiting url
   *
   * @tags meetings
   * @name CancelAMeeting
   * @request GET:/v1/org/meetings/cancel/{meetingId}
   * @secure
   */
  cancelAMeeting = (
    meetingId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingsEndpointsResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/meetings/cancel/${meetingId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cancelAMeeting */
  cancelAMeetingPathGetter = (
    meetingId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
  ) => this.getServicePath(`/v1/org/meetings/cancel/${meetingId}`, query);

  /**
   * @description No show a meeting via visiting url
   *
   * @tags meetings
   * @name NoShowAMeeting
   * @request GET:/v1/org/meetings/noshow/{meetingId}
   * @secure
   */
  noShowAMeeting = (
    meetingId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingsEndpointsResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/meetings/noshow/${meetingId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for noShowAMeeting */
  noShowAMeetingPathGetter = (
    meetingId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
  ) => this.getServicePath(`/v1/org/meetings/noshow/${meetingId}`, query);

  /**
   * @description Redirect to a meeting activity page
   *
   * @tags meetings
   * @name Activity
   * @request GET:/v1/org/meetings/activity/{meetingId}
   * @secure
   */
  activity = (meetingId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/meetings/activity/${meetingId}`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for activity */
  activityPathGetter = (meetingId: string) => this.getServicePath(`/v1/org/meetings/activity/${meetingId}`);

  /**
   * @description Get a meeting by id
   *
   * @tags meetings
   * @name GetMeeting
   * @request GET:/v1/org/meetings/get/{meetingId}
   * @secure
   */
  getMeeting = (meetingId: string, params: RequestParams = {}) =>
    this.request<
      HttpQueryResponseA,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/meetings/get/${meetingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeeting */
  getMeetingPathGetter = (meetingId: string) => this.getServicePath(`/v1/org/meetings/get/${meetingId}`);

  /**
   * @description Query a list of meetings
   *
   * @tags meetings
   * @name BetaVersionMeetings
   * @request GET:/v1/org/meetings/meetings
   * @secure
   */
  betaVersionMeetings = (
    query: {
      /**
       * Page number. First page has index 0.
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * Number of items per page. Maximum is 50
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /** List of workspace ids. If not provided, all workspaces are considered. */
      workspaceIds?: string[];
      /**
       * time of start such as 2025-01-08T13:46:18.681Z (ISO8601 format)
       * @format date-time
       */
      start: string;
      /**
       * time of end such as 2025-01-14T13:46:18.681Z (ISO8601 format)
       * @format date-time
       */
      end: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      HttpQueryResponseA,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/meetings/meetings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for betaVersionMeetings */
  betaVersionMeetingsPathGetter = (query: {
    /**
     * Page number. First page has index 0.
     * @format int64
     * @min 0
     * @default 0
     * @example 0
     */
    page?: number;
    /**
     * Number of items per page. Maximum is 50
     * @format int64
     * @exclusiveMin 0
     * @default 10
     * @example 10
     */
    pageSize?: number;
    /** List of workspace ids. If not provided, all workspaces are considered. */
    workspaceIds?: string[];
    /**
     * time of start such as 2025-01-08T13:46:18.681Z (ISO8601 format)
     * @format date-time
     */
    start: string;
    /**
     * time of end such as 2025-01-14T13:46:18.681Z (ISO8601 format)
     * @format date-time
     */
    end: string;
  }) => this.getServicePath(`/v1/org/meetings/meetings`, query);

  /**
   * @description Export meetings in CSV format
   *
   * @tags meetings
   * @name ExportMeetings
   * @request GET:/v1/org/meetings/meetings/export
   * @secure
   */
  exportMeetings = (
    query: {
      /** List of workspace ids. If not provided, all workspaces are considered. */
      workspaceIds?: string[];
      /**
       * time of start such as 2025-01-08T13:46:18.681Z (ISO8601 format)
       * @format date-time
       */
      start: string;
      /**
       * time of end such as 2025-01-14T13:46:18.681Z (ISO8601 format)
       * @format date-time
       */
      end: string;
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CallerRef,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/meetings/meetings/export`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for exportMeetings */
  exportMeetingsPathGetter = (query: {
    /** List of workspace ids. If not provided, all workspaces are considered. */
    workspaceIds?: string[];
    /**
     * time of start such as 2025-01-08T13:46:18.681Z (ISO8601 format)
     * @format date-time
     */
    start: string;
    /**
     * time of end such as 2025-01-14T13:46:18.681Z (ISO8601 format)
     * @format date-time
     */
    end: string;
    /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
    access_token?: string;
  }) => this.getServicePath(`/v1/org/meetings/meetings/export`, query);

  /**
   * @description Modify an existing rule
   *
   * @tags rule
   * @name ModifyRule
   * @request PUT:/v1/org/rule
   * @secure
   */
  modifyRule = (data: RuleModifyRequest, params: RequestParams = {}) =>
    this.request<
      RuleView,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/rule`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for modifyRule */
  modifyRulePathGetter = () => this.getServicePath(`/v1/org/rule`);

  /**
   * @description Create a new rule
   *
   * @tags rule
   * @name CreateRule
   * @request POST:/v1/org/rule
   * @secure
   */
  createRule = (data: RuleCreateRequest, params: RequestParams = {}) =>
    this.request<
      RuleView,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/rule`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createRule */
  createRulePathGetter = () => this.getServicePath(`/v1/org/rule`);

  /**
   * @description Remove an existing rule
   *
   * @tags rule
   * @name RemoveRule
   * @request DELETE:/v1/org/rule
   * @secure
   */
  removeRule = (data: RuleDeleteRequest, params: RequestParams = {}) =>
    this.request<
      RuleView,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/rule`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for removeRule */
  removeRulePathGetter = () => this.getServicePath(`/v1/org/rule`);

  /**
   * @description List all rules
   *
   * @tags rule
   * @name ListRules
   * @request GET:/v1/org/rule/list
   * @secure
   */
  listRules = (params: RequestParams = {}) =>
    this.request<
      PaginatedResultRuleView,
      {
        errorCode: string;
        errorMessage: string;
        arguments?: MapString;
      }
    >({
      path: `/v1/org/rule/list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listRules */
  listRulesPathGetter = () => this.getServicePath(`/v1/org/rule/list`);

  /**
   * @description List a user's personal scheduling links
   *
   * @tags schedulingLinks
   * @name BetaVersionSchedulingLinks
   * @request GET:/v1/org/schedulingLinks/{userId}
   * @secure
   */
  betaVersionSchedulingLinks = (userId: string, params: RequestParams = {}) =>
    this.request<
      string[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/schedulingLinks/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for betaVersionSchedulingLinks */
  betaVersionSchedulingLinksPathGetter = (userId: string) => this.getServicePath(`/v1/org/schedulingLinks/${userId}`);

  /**
   * @description List round robin scheduling links
   *
   * @tags schedulingLinks
   * @name BetaVersionSchedulingLinksRoundRobin
   * @request POST:/v1/org/schedulingLinks/list-round-robin
   * @secure
   */
  betaVersionSchedulingLinksRoundRobin = (data: RoundRobinSchedulingLinksRequest, params: RequestParams = {}) =>
    this.request<
      SchedulingLinkDetails,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/schedulingLinks/list-round-robin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for betaVersionSchedulingLinksRoundRobin */
  betaVersionSchedulingLinksRoundRobinPathGetter = () =>
    this.getServicePath(`/v1/org/schedulingLinks/list-round-robin`);

  /**
   * @description Cancel a meeting by crm event id via visiting url
   *
   * @tags crm
   * @name CancelACrmEventViaCrmEventId
   * @request GET:/v1/org/crm/cancel/{crmEventId}
   * @secure
   */
  cancelACrmEventViaCrmEventId = (
    crmEventId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CrmEndpointsResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/crm/cancel/${crmEventId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cancelACrmEventViaCrmEventId */
  cancelACrmEventViaCrmEventIdPathGetter = (
    crmEventId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
  ) => this.getServicePath(`/v1/org/crm/cancel/${crmEventId}`, query);

  /**
   * @description No show a meeting by crm event id via visiting url
   *
   * @tags crm
   * @name NoShowACrmMeetingViaCrmEventId
   * @request GET:/v1/org/crm/noshow/{crmEventId}
   * @secure
   */
  noShowACrmMeetingViaCrmEventId = (
    crmEventId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CrmEndpointsResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/crm/noshow/${crmEventId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for noShowACrmMeetingViaCrmEventId */
  noShowACrmMeetingViaCrmEventIdPathGetter = (
    crmEventId: string,
    query?: {
      /** Redirect to this url on success */
      redirectOnSuccess?: string;
      /** Redirect to this url on failure */
      redirectOnFailure?: string;
    },
  ) => this.getServicePath(`/v1/org/crm/noshow/${crmEventId}`, query);

  /**
   * @description Redirect to a meeting activity page via event id
   *
   * @tags crm
   * @name ActivityViaCrmEventId
   * @request GET:/v1/org/crm/activity/{crmEventId}
   * @secure
   */
  activityViaCrmEventId = (crmEventId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/crm/activity/${crmEventId}`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for activityViaCrmEventId */
  activityViaCrmEventIdPathGetter = (crmEventId: string) => this.getServicePath(`/v1/org/crm/activity/${crmEventId}`);

  /**
   * @description (BETA VERSION) Reads Concierge Logs
   *
   * @tags concierge
   * @name BetaVersionReadsConciergeLogs
   * @request POST:/v1/org/concierge/logs
   * @secure
   */
  betaVersionReadsConciergeLogs = (
    query: {
      /**
       * Id of the workspace
       * @pattern [^\s\\/]+
       */
      workspaceId: string;
      /**
       * Concierge Router Id
       * @format uuid
       */
      routerId: string;
      /**
       * time of start such as 2025-01-08T13:46:18.681Z (ISO8601 format)
       * @format date-time
       */
      start: string;
      /**
       * time of end such as 2025-01-14T13:46:18.681Z (ISO8601 format)
       * @format date-time
       */
      end: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      StaticValue,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/org/concierge/logs`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for betaVersionReadsConciergeLogs */
  betaVersionReadsConciergeLogsPathGetter = (query: {
    /**
     * Id of the workspace
     * @pattern [^\s\\/]+
     */
    workspaceId: string;
    /**
     * Concierge Router Id
     * @format uuid
     */
    routerId: string;
    /**
     * time of start such as 2025-01-08T13:46:18.681Z (ISO8601 format)
     * @format date-time
     */
    start: string;
    /**
     * time of end such as 2025-01-14T13:46:18.681Z (ISO8601 format)
     * @format date-time
     */
    end: string;
  }) => this.getServicePath(`/v1/org/concierge/logs`, query);

  /**
   * @description Lists all concierge routers
   *
   * @tags concierge
   * @name ListsAllConciergeRouters
   * @request POST:/v1/org/concierge/routers/concierge/list
   * @secure
   */
  listsAllConciergeRouters = (params: RequestParams = {}) =>
    this.request<
      ConciergeRoutersListResponse,
      {
        errorCode: string;
        errorMessage: string;
        arguments?: MapString;
      }
    >({
      path: `/v1/org/concierge/routers/concierge/list`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listsAllConciergeRouters */
  listsAllConciergeRoutersPathGetter = () => this.getServicePath(`/v1/org/concierge/routers/concierge/list`);
}
